import { BDropdown } from '../BDropdown/BDropdown'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { showModal } from '../../../store/actions/modalActions'
import { ModalTypes } from '../../../types/modals'
import { faFileUpload } from '@fortawesome/free-solid-svg-icons/faFileUpload'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons/faFileDownload'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectProductSystemActions } from '../../../store/selectors/systemActionsSelectors'
import { AppDropdownItem } from '../AppDropdown/AppDropdown'
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear'
import { faEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis'
import { CoreSettings } from '../../CoreSettings/CoreSettings'
import React from 'react'
import { User } from '../../../entity/User'
import { showRightBar } from '../../../store/actions/rightBarActions'

interface DropdownMoreProps {
    guid: string
    className?: string
}

export const DropdownMore = (props: DropdownMoreProps) => {
    const { guid, className } = props
    const dispatch = useAppDispatch()
    const authUser = new User()

    const productSystemActions =
        useAppSelector(selectProductSystemActions(guid)) ?? {}

    const {
        get_configuration_file: hasGetConfigFile,
        set_configuration_file: hasSetConfigFile,
        set_configuration_files: hasSetConfigFiles,
        get_general_settings: hasGetGeneralSettings,
    } = productSystemActions

    const handleUploadConfig = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()

        const uploadConfigModalType = hasSetConfigFiles
            ? ModalTypes.UPLOAD_MULTIPLE_CONFIGS_MODAL
            : ModalTypes.UPLOAD_CONFIG_MODAL

        dispatch(
            showModal(uploadConfigModalType, {
                guid,
            })
        )
    }

    const handleDownloadConfig = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()
        dispatch(
            showModal(ModalTypes.CONFIGS_MODAL, {
                guid,
            })
        )
    }

    const handleOpenGeneralSettings = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()
        dispatch(
            showRightBar({
                rightBarItem: <CoreSettings guid={guid} />,
                disableHide: false
            })
        )
    }

    const uploadConfig: AppDropdownItem = {
        name: hasSetConfigFiles ? 'buttons.uploadConfigs' : 'buttons.uploadConfig',
        icon: faFileUpload,
        action: handleUploadConfig,
        disabled: !hasSetConfigFile && !hasSetConfigFiles,
    }
    const downloadConfig: AppDropdownItem = {
        name: 'buttons.downloadConfig',
        icon: faFileDownload,
        action: handleDownloadConfig,
        disabled: !hasGetConfigFile,
    }
    const generalSettings: AppDropdownItem = {
        name: 'buttons.generalSettings',
        icon: faGear,
        action: handleOpenGeneralSettings,
        disabled: authUser.isViewer() || !hasGetGeneralSettings,
    }

    const dropdownItems = authUser.isFullRightsManagerOrAbove()
        ? [uploadConfig, downloadConfig, generalSettings]
        : [generalSettings]

    const isDisabled =
        authUser.isViewer() ||
        (!hasSetConfigFile &&
            !hasSetConfigFiles &&
            !hasGetConfigFile &&
            !hasGetGeneralSettings)

    return (
        <BDropdown
            hasHr={authUser.isFullRightsManagerOrAbove()}
            className={`rounded-blue-btn ${className}`}
            tooltip="More"
            dropdownItems={dropdownItems}
            icon={faEllipsis}
            isDisabled={isDisabled}
        />
    )
}
